import { render } from "./custom_rule.vue?vue&type=template&id=fddabd82"
import script from "./custom_rule.vue?vue&type=script&lang=js"
export * from "./custom_rule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__